import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import RecruiterDashboardTodayInterviewModel from "../../../models/company/dashboard/response/RecruiterDashboardTodayInterviewModel";

interface TodayInterviewsGridProps {
    interviews: RecruiterDashboardTodayInterviewModel[];
};

const TodayInterviewsGridComponent = (props: TodayInterviewsGridProps) => {

    const columnsInterviews = [
        { Key: "JobCode", text: "JobCode", sort: false, searchable: false },
        { Key: "CandidateName", text: "Name", sort: false, searchable: false },
        { Key: "EmailId", text: "Email Id", sort: false, searchable: false },
        { Key: "MobileNumber", text: "Mobile No", sort: false, searchable: false },
        { Key: "InterviewDate", text: "Interview Dt", sort: false, searchable: false },
        { Key: "MeetingUrl", text: "Meeting Url", sort: false, searchable: false }
    ];
    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsInterviews.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.interviews.map((interview: RecruiterDashboardTodayInterviewModel, index) => (
                                <TableRow>
                                    <TableCell>{interview.jobCode}</TableCell>
                                    <TableCell>{interview.candidateName}</TableCell>
                                    <TableCell>{interview.emailId}</TableCell>
                                    <TableCell>{interview.mobileNumber}</TableCell>
                                    <TableCell>{interview.interviewDate}</TableCell>
                                    <TableCell>
                                        <a href={interview.meetingUrl} target="_blank" title={interview.meetingUrl}>Meeting URL</a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
};
export default TodayInterviewsGridComponent;